import { BaseSortVisitor } from './baseSort.visitor';

export class SortVisitor extends BaseSortVisitor {
}
